import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BpcInvoiceTabs from '@accounting/components/tabs/invoices/invoice-tabs.vue';

@Component({
  name: 'bpc-invoices',
  components: {
    'bpc-invoice-tabs': BpcInvoiceTabs,
    'bpc-page-title': BpcPageTitle,
  },
})
export default class Invoices extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
